import { Navigate } from "react-router-dom";

/**
 * Rota "/" não renderiza conteúdo próprio: apenas direciona para a Home
 * unificada (hub de módulos). A partir daí o menu e os cards levam a cada
 * módulo conforme a visibilidade e o papel (DA-002).
 */
export function HomeRedirect() {
  return <Navigate to="/inicio" replace />;
}
